/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CarrierType } from '../model'
// @ts-ignore
import type { CarrierVisitAreaPartialDto } from '../model'
// @ts-ignore
import type { CarrierVisitDto } from '../model'
// @ts-ignore
import type { CarrierVisitPerformanceDto } from '../model'
// @ts-ignore
import type { CarrierVisitStatus } from '../model'
// @ts-ignore
import type { CarrierVisitWithWorkQueueDto } from '../model'
// @ts-ignore
import type { ExecutedMovesTimeRangeDto } from '../model'
// @ts-ignore
import type { HasWorkInstructionAndCraneWorkQueueDto } from '../model'
// @ts-ignore
import type { VesselGeometryDto } from '../model'
/**
 * CarrierVisitsApi - axios parameter creator
 */
export const CarrierVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CarrierType} [type]
     * @param {boolean} [withFutureEtd]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      type?: CarrierType,
      withFutureEtd?: boolean,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (type !== undefined) {
        localVarQueryParameter['Type'] = type
      }

      if (withFutureEtd !== undefined) {
        localVarQueryParameter['WithFutureEtd'] = withFutureEtd
      }

      if (carrierVisitStatuses) {
        localVarQueryParameter['CarrierVisitStatuses'] = carrierVisitStatuses
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [filter]
     * @param {CarrierType} [type]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisitAreasByPartialName: async (
      filter?: string,
      type?: CarrierType,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/getCarrierVisitAreasByPartialName`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (filter !== undefined) {
        localVarQueryParameter['Filter'] = filter
      }

      if (type !== undefined) {
        localVarQueryParameter['Type'] = type
      }

      if (carrierVisitStatuses) {
        localVarQueryParameter['CarrierVisitStatuses'] = carrierVisitStatuses
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} [carrierVisitIds]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisitsWithWorkQueues: async (
      carrierVisitIds?: Array<number>,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/getCarrierVisitsWithWorkQueues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitIds) {
        localVarQueryParameter['CarrierVisitIds'] = carrierVisitIds
      }

      if (carrierVisitStatuses) {
        localVarQueryParameter['CarrierVisitStatuses'] = carrierVisitStatuses
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExecutedMovesPerCrane: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/getExecutedMovesPerCrane`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHasWorkInstructionAndCraneWorkQueue: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/getHasWorkInstructionAndCraneWorkQueue`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsCraneSplitOutDated: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/getIsCraneSplitOutDated`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOne: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getOne', 'id', id)
      const localVarPath = `/operations/api/CarrierVisits/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVesselBay: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/GetVesselBay`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['carrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVisitPerformance: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CarrierVisits/GetVisitPerformance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CarrierVisitsApi - functional programming interface
 */
export const CarrierVisitsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CarrierVisitsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CarrierType} [type]
     * @param {boolean} [withFutureEtd]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      type?: CarrierType,
      withFutureEtd?: boolean,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        type,
        withFutureEtd,
        carrierVisitStatuses,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [filter]
     * @param {CarrierType} [type]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCarrierVisitAreasByPartialName(
      filter?: string,
      type?: CarrierType,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitAreaPartialDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierVisitAreasByPartialName(
        filter,
        type,
        carrierVisitStatuses,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getCarrierVisitAreasByPartialName']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} [carrierVisitIds]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCarrierVisitsWithWorkQueues(
      carrierVisitIds?: Array<number>,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CarrierVisitWithWorkQueueDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierVisitsWithWorkQueues(
        carrierVisitIds,
        carrierVisitStatuses,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getCarrierVisitsWithWorkQueues']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExecutedMovesPerCrane(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExecutedMovesTimeRangeDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutedMovesPerCrane(
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getExecutedMovesPerCrane']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHasWorkInstructionAndCraneWorkQueue(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HasWorkInstructionAndCraneWorkQueueDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getHasWorkInstructionAndCraneWorkQueue(
          carrierVisitId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getHasWorkInstructionAndCraneWorkQueue']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIsCraneSplitOutDated(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getIsCraneSplitOutDated(
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getIsCraneSplitOutDated']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOne(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierVisitDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOne(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getOne']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVesselBay(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VesselGeometryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselBay(
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getVesselBay']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVisitPerformance(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierVisitPerformanceDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitPerformance(
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CarrierVisitsApi.getVisitPerformance']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CarrierVisitsApi - factory interface
 */
export const CarrierVisitsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CarrierVisitsApiFp(configuration)
  return {
    /**
     *
     * @param {CarrierType} [type]
     * @param {boolean} [withFutureEtd]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      type?: CarrierType,
      withFutureEtd?: boolean,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CarrierVisitDto>> {
      return localVarFp
        .get(type, withFutureEtd, carrierVisitStatuses, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [filter]
     * @param {CarrierType} [type]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisitAreasByPartialName(
      filter?: string,
      type?: CarrierType,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CarrierVisitAreaPartialDto>> {
      return localVarFp
        .getCarrierVisitAreasByPartialName(filter, type, carrierVisitStatuses, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} [carrierVisitIds]
     * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarrierVisitsWithWorkQueues(
      carrierVisitIds?: Array<number>,
      carrierVisitStatuses?: Array<CarrierVisitStatus>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CarrierVisitWithWorkQueueDto>> {
      return localVarFp
        .getCarrierVisitsWithWorkQueues(carrierVisitIds, carrierVisitStatuses, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExecutedMovesPerCrane(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ExecutedMovesTimeRangeDto>> {
      return localVarFp
        .getExecutedMovesPerCrane(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHasWorkInstructionAndCraneWorkQueue(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HasWorkInstructionAndCraneWorkQueueDto> {
      return localVarFp
        .getHasWorkInstructionAndCraneWorkQueue(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsCraneSplitOutDated(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .getIsCraneSplitOutDated(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOne(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CarrierVisitDto> {
      return localVarFp.getOne(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVesselBay(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<VesselGeometryDto> {
      return localVarFp
        .getVesselBay(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVisitPerformance(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CarrierVisitPerformanceDto> {
      return localVarFp
        .getVisitPerformance(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * CarrierVisitsApi - object-oriented interface
 */
export class CarrierVisitsApi extends BaseAPI {
  /**
   *
   * @param {CarrierType} [type]
   * @param {boolean} [withFutureEtd]
   * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(
    type?: CarrierType,
    withFutureEtd?: boolean,
    carrierVisitStatuses?: Array<CarrierVisitStatus>,
    options?: RawAxiosRequestConfig,
  ) {
    return CarrierVisitsApiFp(this.configuration)
      .get(type, withFutureEtd, carrierVisitStatuses, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [filter]
   * @param {CarrierType} [type]
   * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCarrierVisitAreasByPartialName(
    filter?: string,
    type?: CarrierType,
    carrierVisitStatuses?: Array<CarrierVisitStatus>,
    options?: RawAxiosRequestConfig,
  ) {
    return CarrierVisitsApiFp(this.configuration)
      .getCarrierVisitAreasByPartialName(filter, type, carrierVisitStatuses, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} [carrierVisitIds]
   * @param {Array<CarrierVisitStatus>} [carrierVisitStatuses]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCarrierVisitsWithWorkQueues(
    carrierVisitIds?: Array<number>,
    carrierVisitStatuses?: Array<CarrierVisitStatus>,
    options?: RawAxiosRequestConfig,
  ) {
    return CarrierVisitsApiFp(this.configuration)
      .getCarrierVisitsWithWorkQueues(carrierVisitIds, carrierVisitStatuses, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getExecutedMovesPerCrane(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return CarrierVisitsApiFp(this.configuration)
      .getExecutedMovesPerCrane(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getHasWorkInstructionAndCraneWorkQueue(
    carrierVisitId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return CarrierVisitsApiFp(this.configuration)
      .getHasWorkInstructionAndCraneWorkQueue(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getIsCraneSplitOutDated(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return CarrierVisitsApiFp(this.configuration)
      .getIsCraneSplitOutDated(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOne(id: number, options?: RawAxiosRequestConfig) {
    return CarrierVisitsApiFp(this.configuration)
      .getOne(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getVesselBay(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return CarrierVisitsApiFp(this.configuration)
      .getVesselBay(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getVisitPerformance(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return CarrierVisitsApiFp(this.configuration)
      .getVisitPerformance(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
